<template>
    <b-row no-gutters class="login-row">
        <b-col align-self="center" class="px-2 text-center">
            <b-img :src="logo" alt="logo-moregiros" class="logo-small"/>
            <b-form id="formRegister" @submit.stop.prevent="submit" class="form-signin pt-4">
                <b-form-group>
                    <b-form-input
                        id="name"
                        name="name"
                        type="text"
                        v-model="form.name"
                        class="text-center"
                        :placeholder="labels.name"
                        v-validate="{ required: true, min: 3, max: 50 }"
                        :state="validateState('name')"
                        aria-describedby="name-live-feedback"
                        :data-vv-as="(labels.name).toLowerCase()"
                        :disabled="loading"
                        size="lg"
                        autofocus/>
                    <b-form-invalid-feedback id="name-live-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group>
                    <b-form-input
                        id="lname"
                        name="lname"
                        type="text"
                        v-model="form.lname"
                        class="text-center"
                        :placeholder="labels.lname"
                        v-validate="{ required: true, min: 3, max: 50 }"
                        :state="validateState('lname')"
                        aria-describedby="lname-live-feedback"
                        :data-vv-as="(labels.lname).toLowerCase()"
                        :disabled="loading"
                        size="lg"/>
                    <b-form-invalid-feedback id="lname-live-feedback">{{ veeErrors.first('lname') }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group>
                    <b-form-input
                        id="mname"
                        name="mname"
                        type="text"
                        v-model="form.mname"
                        class="text-center"
                        :placeholder="labels.mname"
                        v-validate="{ min: 3, max: 50 }"
                        :state="validateState('mname')"
                        aria-describedby="mname-live-feedback"
                        :data-vv-as="(labels.mname).toLowerCase()"
                        :disabled="loading"
                        size="lg"/>
                    <b-form-invalid-feedback id="mname-live-feedback">{{ veeErrors.first('mname') }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group>
                    <b-form-input
                        id="phone"
                        name="phone"
                        type="tel"
                        inputmode="tel"
                        v-model="form.phone"
                        class="text-center"
                        :placeholder="labels.phone"
                        v-validate="'numeric|required:true'"
                        :state="validateState('phone')"
                        aria-describedby="phone-live-feedback"
                        :data-vv-as="(labels.phone).toLowerCase()"
                        :disabled="loading"
                        size="lg"/>
                    <b-form-invalid-feedback id="phone-live-feedback">{{ veeErrors.first('phone') }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group>
                    <b-form-input
                        id="email"
                        name="email"
                        type="email"
                        v-model="form.email"
                        class="text-center"
                        :placeholder="labels.email"
                        v-validate="'required:true|email'"
                        :state="validateState('email')"
                        aria-describedby="email-live-feedback"
                        :data-vv-as="(labels.email).toLowerCase()"
                        :disabled="loading"
                        size="lg"/>
                    <b-form-invalid-feedback id="email-live-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group>
                    <b-input-group>
                        <b-form-input
                            id="password"
                            ref="password"
                            name="password"
                            :type="passwordHidden ? 'password' : 'text'"
                            v-model="form.password"
                            class="text-center"
                            :placeholder="labels.password"
                            v-validate="{ required: true, min: 8 }"
                            :state="validateState('password')"
                            aria-describedby="password-live-feedback"
                            :data-vv-as="(labels.password).toLowerCase()"
                            :disabled="loading"
                            size="lg"/>
                        <b-input-group-append>
                            <b-button variant="outline-default" @click="passwordHidden = !passwordHidden"
                                      class="m-0 btlr-0 bblr-0">
                                <i class="material-icons">{{ passwordHidden ? 'visibility_off' : 'visibility' }}</i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback id="password-live-feedback">{{ veeErrors.first('password') }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group>
                    <b-input-group>
                        <b-form-input
                            id="confirmPassword"
                            name="confirmPassword"
                            :type="passwordHidden ? 'password' : 'text'"
                            v-model="form.password_confirmation"
                            class="text-center"
                            :placeholder="labels.password_confirmation"
                            v-validate="{ required: true, confirmed: 'password', min: 8 }"
                            :state="validateState('confirmPassword')"
                            aria-describedby="confirm-password-live-feedback"
                            :data-vv-as="(labels.password_confirmation).toLowerCase()"
                            :disabled="loading"
                            size="lg"/>
                        <b-input-group-append>
                            <b-button variant="outline-default" @click="passwordHidden = !passwordHidden"
                                      class="m-0 btlr-0 bblr-0">
                                <i class="material-icons">{{ passwordHidden ? 'visibility_off' : 'visibility' }}</i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback id="confirm-password-live-feedback">{{ veeErrors.first('confirmPassword') }}</b-form-invalid-feedback>
                </b-form-group>

                <p class="mt-4 d-block text-secondary">{{ labels.termsText }}
                    <b-button variant="link" v-b-modal.terms>{{ labels.terms }}</b-button>
                </p>
            </b-form>
            <b-modal id="terms" header-bg-variant="primary" header-text-variant="light" hide-footer size="lg"
                     centered scrollable no-close-on-backdrop no-close-on-esc hide-header-close>
                <template #modal-title>
                    <div class="text-center">{{ labels.terms }}</div>
                </template>
                <div v-html="content"></div>
                <b-button class="mt-3" block @click="$bvModal.hide('terms')"
                    variant="default">Cerrar</b-button>
            </b-modal>
        </b-col>

        <!-- login buttons -->
        <b-row align-h="center" class="mx-0 bottom-button-container">
            <b-col align-self="center">
                <b-button type="submit" variant="default" size="lg" pill block class="shadow"
                          form="formRegister" :disabled="loading">
                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                    <b-icon icon="person-check-fill" aria-hidden="true" v-else></b-icon>
                    <span class="v-align-baseline">{{ loading ? labels.load : labels.register }}</span>
                </b-button>
            </b-col>
        </b-row>
        <!-- login buttons -->
    </b-row>
</template>

<script>
import axios from 'axios';

export default {
    name: 'Login',
    data: () => ({
        logo: '/img/logo_login.png',
        dialog: false,
        passwordHidden: true,
        labels: {
            name: 'Nombres',
            lname: 'Primer Apellido',
            mname: 'Segundo Apellido',
            phone: 'Teléfono',
            email: 'Correo Electrónico',
            password: 'Contraseña',
            password_confirmation: 'Confirmar Contraseña',
            termsText: 'Al hacer clic en registrarme, acepto los',
            terms: 'Términos & Condiciones',
            load: 'Creando Cuenta...',
            register: 'Crear Cuenta'
        },
        form: {
            name: null,
            lname: null,
            mname: null,
            phone: null,
            email: null,
            password: null,
            password_confirmation: null
        },
        loading: false,
        title: '',
        content: ''
    }),
    mounted() {
        this.loginRow();
        window.addEventListener("resize", this.loginRow);
        this.$emit('loader');
        this.getData();
    },
    methods: {
        getData() {
            this.loading = true;
            axios.get('/api/terms').then((res) => {
                this.title = res.data.terms.title;
                this.content = res.data.terms.content;
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.loading = false;
            });
        },
        loginRow() {
            $('.login-row').css('min-height', ($(window).height() - 80));
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.form = {
                name: null,
                lname: null,
                mname: null,
                phone: null,
                email: null,
                password: null,
                password_confirmation: null
            };

            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        submit() {
            this.$validator.validateAll().then(result => {
                if (!result) { return; }
                this.loading = true;
                axios.post('/api/register', this.form).then((res) => {
                    this.$root.$bvToast.toast('¡Te has registrado exitosamente!', {
                        title: 'Felicitaciones',
                        headerClass: 'd-none',
                        variant: 'success',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    this.success(res.data);
                }).catch(err => {
                    this.loading = false;
                });
            });
        },
        success(data) {
            this.$store.dispatch('saveToken', data);
            this.$store.dispatch('setUser', data);
            this.$router.push({ name: 'Welcome' });
        }
    }
}
</script>

<style scoped>
.header + div {
    padding-top: 5px;
}
</style>
